/**
 * Used to asynchronously load framer motion
 * @link https://www.framer.com/docs/guide-reduce-bundle-size/#async-loading
 */

import { domAnimation } from 'framer-motion';
export default domAnimation;
